<script>
    import ActionButton from './popups/components/ActionButton.svelte';

    import { mapMultiSelectMode } from './stores/stores';

    export let endMultiSelectMode;

    export let mergeSelectedPlaygrounds;

    /**
     * The busy store of the action runner owning the merge action.
     */
    export let busy;

    export let selected = [];
</script>

<div class="map-dialog" style="visibility: {$mapMultiSelectMode ? 'visible' : 'hidden'}">
    {#if selected.length > 1}
        <p>
            {selected.length} lekplatser markerade
        </p>

        <ActionButton {busy} action={mergeSelectedPlaygrounds} variant="btn-warning">Slå ihop</ActionButton>
    {:else}
        <p>Markera minst två lekplatser genom att klicka på dem</p>
    {/if}
    <button class="btn btn-sm btn-secondary" on:click={endMultiSelectMode}>Avbryt</button>
</div>

<style>
    /* The bar takes its height from what is in it rather than being held at 50px. The
       message runs to two lines on a phone, and everything past the first line used to hang
       out below the black instead of the bar growing to hold it.

       The inset keeps the bar clear of the home indicator. */
    .map-dialog {
        position: absolute;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px 12px;
        background: black;
        color: #eee;
        bottom: calc(20px + env(safe-area-inset-bottom, 0px));
        right: 20px;
        left: 20px;
        min-height: 50px;
        padding: 8px 20px;
        z-index: 1000;
        border-radius: 25px;
        opacity: 80%;
    }

    /* Asks for little and then takes whatever the buttons leave, so the message wraps within
       itself and they stay on the line beside it. Asking for its full width instead would
       put them on a line of their own underneath. When even this doesn't fit, the message
       takes the line and the buttons drop below it. */
    .map-dialog p {
        flex: 1 1 12ch;
        margin: 0;
    }

    /* Global as well, since the merge button lives in its own component */
    .map-dialog button,
    .map-dialog :global(button) {
        flex-shrink: 0;
        margin: 0;
    }
</style>
